import React from 'react';
import {Link} from "react-router-dom";

const SidebarHeader = ({onClose}) => {
  return (
    <div className="pro-header">
      <Link to="/">
        <img src="/images/Logo-GTH-24.png"
             alt="Groupe Talent Handicap"
             width={265} height={50}/>
      </Link>

      <button className="fix-icon"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={onClose}>
        <span className="flaticon-close"></span>
      </button>
    </div>
  );
};

export default SidebarHeader;
